export const withinMaxWidgetLimit = 2;

export const WIDGET_REDUCER_ACTIONS = {
  UPDATE_MAX_WIDGETS: 'UPDATE_MAX_WIDGETS',
  UPDATE_WIDGET_LIST: 'UPDATE_WIDGET_LIST'
};
